import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../lib/axios";
import { API_PORTAL_URL } from "../../../lib/config";
import { SuccessToast } from "../../../components/common/Toast";

export const insertLead = createAsyncThunk(
  "Website/InsertWebsiteLead",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Website/InsertWebsiteLead`,
        formdata,
      );
      SuccessToast(response.data?.Data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error inserting Lead:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveWebBranches = createAsyncThunk(
  "WebsiteBranch/FindAllActiveWebsiteBranch",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/WebsiteBranch/FindAllActiveWebsiteBranch`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Branches:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const emailSubscribe = createAsyncThunk(
  "Website/InsertNewsLetter",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Website/InsertNewsLetter`,
        formdata,
      );
      SuccessToast(response.data?.Data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error subscribing:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
